module.exports = __webpack_public_path__ + "static/media/feedback-white.ffe444f3.svg";